import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import Cart from '../../../shared-components/Cart/Cart';
import PropTypes from 'prop-types';
import _ from 'lodash';

export class Header extends Component {

    static propTypes = {
        intl: intlShape.isRequired,
        cartAmount: PropTypes.string,
        msg: PropTypes.string,
        singleColumnLayout: PropTypes.bool,
        isMobile: PropTypes.bool
    };

    isTransactional(cartAmount) {
        if (cartAmount && cartAmount != '0') {
            return true;
        }
    }

    render() {
        const { intl, cartAmount, singleColumnLayout, msg } = this.props;
        const { isMobile } = this.props;
        const isTransactional = this.isTransactional(cartAmount);
        // hide header for generic error pages
        // or when the header would be empty
        if (!isTransactional && !msg) {
            return null;
        }
        return (
            <header className="Header">
                <div className="row-fluid">
                    <div className={singleColumnLayout ? 'span24' : 'span12'}>
                        <div id="cue-header" className="clearfix section-border-bottom">
                            <div id="cue-header-left" className="pull-left vertical-middle">
                                <h1 className="alpha" id="de-header">{msg}</h1>
                            </div>
                            <div id="cue-header-right" className="pull-right vertical-middle">
                                <div id="cart-header">
                                    {isTransactional && <Cart />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        );
    }
}

export const mapStateToProps = state => {
    return {
        cartAmount: _.get(state, 'serverData.cart.subtotal'),
        isMobile: _.get(state, 'serverData.isMobile')
    };
};

export default connect(mapStateToProps)(injectIntl(Header));
